
import { Link } from "react-router-dom";
export default function OfferStrip()
{

return(

<section className="offer strip">
  <div className="container">
    <div className="strip-data">
      <Link to="/properties?location=Varthur">
        <div className="strip-marquee">
          <div className="strip-track">
            {[1, 2, 3, 4].map((item) => (
              <span className="strip-item" key={item}>
                <span className="offer-badge">FESTIVE OFFER</span>
                Dussehra & Diwali Special — Get 7% OFF on
                Bhavana Arcade Monthly Rent
                <span className="offer-highlight">
                  Save up to ₹1,680/month
                </span>
                <span className="strip-separator">✦</span>
                Offer valid from 15 October to 10 November 2026.
                 <span className="strip-separator">✦</span>
                 Applicable only to the specified flats booked during the offer period.
              </span>
            ))}
          </div>
        </div>
      </Link>
    </div>
  </div>
</section>
)
}
